<div class="splash" role="status" aria-label="Loading Bitraze AI">
  <div class="orb"><img src="assets/logo.png" alt="Bitraze AI" /></div>
  <p class="eyebrow">WELCOME TO BORDERLESS COMMERCE</p>
  <h1>Buy anywhere through <span>BTZAI Tokens</span></h1>
  <div class="loader"><i></i></div>
</div>
